/**
 * Transaction filter: transaction properties and user properties (same as events).
 * Used by TransactionPropertyFilterModule.
 */

export const getTransactionProperties = () => [
  { name: 'function_name', label: 'Function name', type: 'string', source: 'transaction' },
  { name: 'block_no', label: 'Block no', type: 'number', source: 'transaction' },
  { name: 'value', label: 'Value', type: 'number', source: 'transaction' },
  { name: 'decoded_input.address', label: 'Decoded: address', type: 'string', source: 'transaction' },
  { name: 'decoded_input.uint256', label: 'Decoded: uint256', type: 'string', source: 'transaction' },
  { name: 'decoded_input.methodId', label: 'Decoded: methodId', type: 'string', source: 'transaction' },
];

export const getUserPropertiesForTransaction = () => [
  { name: 'user.is_identified', label: 'Is Identified', type: 'boolean', source: 'user' },
  { name: 'user.is_bounce', label: 'Is Bounce', type: 'boolean', source: 'user' },
  { name: 'user.is_web3_user', label: 'Is Web3 User', type: 'boolean', source: 'user' },
  { name: 'user.is_wallet_connected', label: 'Is Wallet Connected', type: 'boolean', source: 'user' },
  { name: 'user.transacted_user', label: 'Transacted User', type: 'boolean', source: 'user' },
  { name: 'user.first_visit', label: 'First Visit', type: 'datetime', source: 'user' },
  { name: 'user.last_visit', label: 'Last Visit', type: 'datetime', source: 'user' },
  { name: 'user.total_page_views', label: 'Total Page Views', type: 'number', source: 'user' },
  { name: 'user.total_time_spent', label: 'Total Time Spent', type: 'number', source: 'user' },
  { name: 'user.first_referrer', label: 'First Referrer', type: 'string', source: 'user' },
  { name: 'user.last_referrer', label: 'Last Referrer', type: 'string', source: 'user' },
  { name: 'user.first_location_city', label: 'First Location City', type: 'string', source: 'user' },
  { name: 'user.first_location_country', label: 'First Location Country', type: 'string', source: 'user' },
  { name: 'user.last_location_city', label: 'Last Location City', type: 'string', source: 'user' },
  { name: 'user.last_location_country', label: 'Last Location Country', type: 'string', source: 'user' },
  { name: 'user.device_type', label: 'Device Type', type: 'string', source: 'user' },
  { name: 'user.browser_name', label: 'Browser Name', type: 'string', source: 'user' },
  { name: 'user.os', label: 'Operating System', type: 'string', source: 'user' },
];

function getDefaultOperator(type) {
  switch (type) {
    case 'string': return 'is';
    case 'number': return 'equal';
    case 'boolean': return 'is_true';
    case 'datetime':
    case 'date': return 'between';
    default: return 'is';
  }
}

/**
 * Same operator set as events (EventsFilterModule / EventPropertyFilterModule getOperatorsForType).
 * Backend maps these to its internal operators where needed.
 */
export const getOperatorsForTransactionType = (type) => {
  switch (type) {
    case 'string':
      return [
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is not' },
        { value: 'contains', label: 'Contains' },
        { value: 'does_not_contain', label: 'Does not contain' },
        { value: 'is_set', label: 'Is set' },
        { value: 'is_not_set', label: 'Is not set' },
      ];
    case 'number':
      return [
        { value: 'equal', label: 'Equals' },
        { value: 'not_equal', label: 'Not equal' },
        { value: 'greater_than', label: 'Greater than' },
        { value: 'greater_than_equal', label: 'Greater than or equal to' },
        { value: 'less_than', label: 'Less than' },
        { value: 'less_than_equal', label: 'Less than or equal to' },
        { value: 'between', label: 'Between' },
        { value: 'not_between', label: 'Not between' },
        { value: 'is_numeric', label: 'Is numeric' },
        { value: 'is_not_numeric', label: 'Is not numeric' },
      ];
    case 'boolean':
      return [
        { value: 'is_true', label: 'Is true' },
        { value: 'is_false', label: 'Is false' },
      ];
    case 'datetime':
    case 'date':
      return [
        { value: 'last', label: 'Last' },
        { value: 'not_in_the_last', label: 'Not in the last' },
        { value: 'between', label: 'Between' },
        { value: 'not_between', label: 'Not between' },
        { value: 'on', label: 'On' },
        { value: 'not_on', label: 'Not on' },
        { value: 'before_the_last', label: 'Before the last' },
        { value: 'before', label: 'Before' },
        { value: 'since', label: 'Since' },
        { value: 'in_the_next', label: 'In the next' },
      ];
    default:
      return [
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is not' },
        { value: 'contains', label: 'Contains' },
        { value: 'is_set', label: 'Is set' },
        { value: 'is_not_set', label: 'Is not set' },
      ];
  }
};

export { getDefaultOperator };
